import React from 'react';
import { withRouter, RouteComponentProps, Link } from 'react-router-dom';
import { Location } from 'history';

import { TranslateScope, Translate } from '@pegasus/translation/components';

import { A } from '../../shared/components/A';

import config from './config';
import { Wrapper, Header, Item, List, ItemTitle, HR } from './SideMenu.styles';

const renderList = (location: Location<{}>, isLegacy: boolean = false) => {
    return Object.keys(config).map((key, index) => {
        if (key === 'default') return null;
        const list = config[key];
        return (
            <React.Fragment key={key}>
                {list.map(item => {
                    return (
                        <Item
                            as={!isLegacy && item.internal ? Link : A}
                            highlighted={
                                item.url === '/myaccount'
                                    ? location.pathname === item.url
                                    : location.pathname.includes(item.url)
                            }
                            key={item.title}
                            to={item.url}
                        >
                            <ItemTitle>
                                <Translate message={item.title} />
                            </ItemTitle>
                        </Item>
                    );
                })}
                {index < Object.keys(config).length - 1 && <HR />}
            </React.Fragment>
        );
    });
};

const _SideMenu = (props: RouteComponentProps & { isLegacy?: boolean }) => (
    <TranslateScope path="sideMenu">
        <Wrapper isLegacy={props.isLegacy}>
            <Header>
                <Translate message="header" />
            </Header>
            <List>{renderList(props.location, props.isLegacy)}</List>
        </Wrapper>
    </TranslateScope>
);

export const SideMenu = withRouter(_SideMenu);
